import { buttonRecipe } from './button.recipe'
import { inputRecipe, textareaRecipe, nativeSelectSlotRecipe } from './field.recipe'
import { checkboxSlotRecipe, radioSlotRecipe } from './selection.recipe'
import { tableSlotRecipe } from './table.recipe'
import { badgeRecipe } from './badge.recipe'

// Non-slot component recipes, merged over defaultConfig in theme.ts.
export const recipes = {
  button: buttonRecipe,
  input: inputRecipe,
  textarea: textareaRecipe,
  badge: badgeRecipe,
}

// Slot recipes. Keys must match Chakra v3's installed slot-recipe keys
// exactly ("checkbox", "radioGroup", "table" — confirmed against
// node_modules/@chakra-ui/react/dist/esm/theme/slot-recipes.js) so
// createSystem deep-merges these overrides into the stock recipe at the same
// key instead of registering an orphaned recipe.
export const slotRecipes = {
  nativeSelect: nativeSelectSlotRecipe,
  checkbox: checkboxSlotRecipe,
  radioGroup: radioSlotRecipe,
  table: tableSlotRecipe,
}
